import { ApiResponse } from '../types'

const apiResponseHandler = <T>(res: ApiResponse<T>) => {
  if (res.ok) return res.result

  if (!res.ok) {
    let errorMessage = 'Произошла ошибка при обращении к серверу'

    if (typeof res.error === 'string') {
      errorMessage = res.error
    } else if (res.error?.message) {
      errorMessage = res.error.message
    } else if (res.message) {
      if (typeof res.message === 'string') {
        errorMessage = res.message
      } else if (Array.isArray(res.message)) {
        errorMessage = res.message.map((m) => (typeof m === 'string' ? m : m.message)).join(', ')
      }
    }

    console.error('API Error:', {
      status: res.status,
      message: res.message,
      error: res.error,
    })

    throw new Error(errorMessage)
  }
}

export default apiResponseHandler
